module.exports = __webpack_public_path__ + "static/media/home_intro_thumb.4c3774ea.png";